
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/split-pdf",
      function () {
        return require("private-next-pages/split-pdf.js");
      }
    ]);
  